
<div class="flex p-2">
    <div class="flex-1 flex align-items-center justify-content-center">
        <p-message severity="warn" text="You do not have permission to access the page you requested!"></p-message>
    </div>
</div>